import {useTranslation} from "next-i18next";
import {Box, Typography, Grid, Button} from "@mui/material";
import {TripInterface} from "../types/trip";
import React, {FC} from "react";
import Image from "next/legacy/image";
import googleBucketLoader from "../lib/google-bucket-loader";
import tripImagesById from "../generated/trip-images-by-id.json";
import {DynamicTypeIcon} from "./dynamic-type-icon";
import {useForex} from "../hooks/use-forex";
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import NextLink from "next-translate-routes/link";
import tripDatabase from "../generated/trip-database.json";


interface RecommendedTripAdProps {
    diveTrip: TripInterface
}

export const RecommendedTripAd: FC<RecommendedTripAdProps> = ({diveTrip}) => {

    const {t, i18n} = useTranslation()

    const {convertCurrency} = useForex();

    const formattedCurrency = convertCurrency(diveTrip.offerPrice?.USD ?? 0, "USD");


    const tripImageFilename = tripImagesById[diveTrip.tripId as keyof typeof tripImagesById]?.[0]

    const image = tripImageFilename ? `/content/trips/${diveTrip.tripId}/img/${tripImageFilename}` : "/images/placeholder/1280x853.png"

    return <Box
        sx={{position: "relative", mb: 2}}

    >

        <Image
            loader={googleBucketLoader}
            placeholder={image.indexOf("placeholder") > 0 ? undefined : "blur"}
            blurDataURL={tripDatabase[diveTrip.tripId as keyof typeof tripDatabase]?.firstImageBlurDataURL || ""}
            sizes={"30vw"}
            src={image} width={1280} height={853}
            layout={"responsive"}
            objectFit={"cover"}
        />


        <Box sx={{
            fontSize: "1rem",
            color: "white",
            backgroundColor: "rgba(0,0,0,.4)",
            display: "block",
            zIndex: 1,
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            pl: 1,
            pr: 2,
            py: 1
        }}>


            <Grid container justifyContent={"space-between"} alignItems={"center"}>

                <Grid item>
                    {diveTrip.region}<br/>
                    <DynamicTypeIcon
                        sx={{
                            // position: "absolute",
                            // right: 0,
                            width: 50,
                            height: 50,
                            verticalAlign: "middle"
                            // top: "30%",
                            // color: "#ffffff"
                        }}

                        diveType={diveTrip.diveType}
                        style={{fontSize: 120}}
                    />


                </Grid>

                <Grid item flexGrow={1} pr={2}>
                    <Grid container direction={"column"} justifyContent={"end"} justifyItems={"right"}>
                        <Grid item textAlign={"right"}>
                            <Typography display={"inline"} fontWeight={700}
                                        color={"primary.light"}>{diveTrip.offer}</Typography>
                        </Grid>
                        <Grid item textAlign={"right"}>
                            {t("starting-from")}
                        </Grid>
                        <Grid item textAlign={"right"}>
                            <Typography  fontWeight={700}>{formattedCurrency}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <NextLink href={{
                        pathname: "/diving/[countrySlug]/[tripSlug]",
                        query: {
                            countrySlug: diveTrip?.country?.slug,
                            tripSlug: diveTrip?.slug
                        }
                    }}>
                    <Button variant={"contained"} color={"secondary"} sx={{
                        padding: '12px 4px',
                    }}><DoubleArrowIcon/></Button>
                    </NextLink>
                </Grid>

            </Grid>


        </Box>

    </Box>

}
